import AbstractRepository from "@/repositories/AbstractRepository";

export default class NotificationRepository extends AbstractRepository {
    protected static resource: string = "ptf-notification";

    protected static defaultFields: string[] = [
        "uuid",
        "triggers",
        "channels",
        "owner.uuid",
        "hierarchyOwner.uuid",
        "hierarchyOwner.fullName",
        "module",
        "isActive"
    ];
}
